import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ContextMenuAction, ContextMenuItem } from '@nstep-common/core';

@Component({
	selector: 'app-context-menu',
	templateUrl: './context-menu.component.html',
	standalone: false
})
export class ContextMenuComponent {
	@Input() contextMenuItems: ContextMenuItem[] = [];
	@Input() contextMenuStyle: {} | null = null;
	@Output() contextMenuItemClick = new EventEmitter<ContextMenuAction>();

	onContextMenuItemClick(item: ContextMenuItem): void {
		this.contextMenuItemClick.emit(item.actionValue!);
	}
}
